<template>
  <div class="product">
    <!-- 顶部横幅 -->
<!--    <div class="top">
      <img :src="top" style="width: 100%;height: 450px">
    </div>-->

    <div class="background">
      <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
      <div class="background-text">
        <p>产品展示</p>
      </div>
    </div>
    
    <!-- 主内容区域 -->
    <div class="con_data">
      <!-- 标题区域 -->
      <div class="page-header">
        <h1 class="blue">产品中心</h1>
        <div class="header-divider"></div>
        <p class="header-subtitle">专业智能混凝土解决方案提供商</p>
      </div>
      
      <div class="content-wrapper">
        <!-- 左侧导航栏 -->
        <div class="category-sidebar">
          <div class="category-title">产品分类</div>
          <div class="category-list">
            <div 
              v-for="(item, index) in CateName" 
              :key="index"
              :class="['category-item', { active: activeIndex === index }]"
              @click="handleMenuClick(index, item)"
            >
              <span class="category-icon"></span>
              <span class="category-name">{{ item.CateName }}</span>
            </div>
          </div>
        </div>
        
        <!-- 产品展示区域 -->
        <div class="product-showcase">
          <transition-group name="fade-list" tag="div" class="product-grid">
            <div class="product-card" v-for="(item, index) in ImgData" :key="item.Id">
              <router-link :to="{path:'/proDetails',query:{Id:item.Id}}">
                <div class="product-image">
                  <img :src="item.ProductImg" :alt="item.ProductName">
                </div>
                <div class="product-info">
                  <h3 class="product-title">{{item.ProductName}}</h3>
                  <p class="product-brief" v-if="item.ProductBrief">{{item.ProductBrief}}</p>
                  <div class="product-action">
                    <span class="view-details">查看详情</span>
                  </div>
                </div>
              </router-link>
            </div>
          </transition-group>
          
          <!-- 无数据提示 -->
          <div class="no-data" v-if="ImgData.length === 0">
            <i class="el-icon-warning-outline"></i>
            <p>暂无相关产品</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "company",
  mounted() {
    this.getTop()
    this.getNav()
  },
  data(){
    return {
      top:'',
      CateName:[],
      Id:'',
      ImgData:[],
      activeIndex: 0,
      img_1:require('../../assets/04.png'),
    }
  },

  methods: {
    getTop(){
      let data={params:{ImgCate:11}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取导航
    getNav(){
      let data={params:{ParentId:3}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/Byt_ent_categorySelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        console.log('导航数据:', res.data);
        this.CateName = res.data;
        if(res.data && res.data.length > 0) {
          this.getImg(res.data[0].Id);
        }
      }).catch(err => {
        console.error('获取导航数据失败:', err);
      })
    },
    
    handleMenuClick(index, item) {
      console.log('点击的导航项:', item);
      this.activeIndex = index;
      this.getImg(item.Id);
    },
    
    getImg(id){
      let data = {params:{ProductCate:id}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntProductSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        console.log('图片数据:', res.data);
        this.ImgData = res.data;
      }).catch(err => {
        console.error('获取图片数据失败:', err);
      })
    }
  }
}
</script>

<style scoped>
/* 页面标题区域 */
.page-header {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
}

.page-header h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 15px;
  letter-spacing: 1px;
}

.header-divider {
  width: 60px;
  height: 3px;
  background: #1890ff;
  margin: 0 auto 15px;
}

.header-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

/* 内容布局 */
.content-wrapper {
  display: flex;
  gap: 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* 左侧分类导航 */
.category-sidebar {
  width: 240px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  padding: 25px 0;
  border-radius: 12px 0 0 12px;
}

.category-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 0 25px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 15px;
}

.category-list {
  display: flex;
  flex-direction: column;
}

.category-item {
  display: flex;
  align-items: center;
  padding: 12px 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.category-item:hover {
  background: rgba(24, 144, 255, 0.05);
}

.category-item.active {
  background: rgba(24, 144, 255, 0.1);
  color: #1890ff;
  font-weight: 500;
}

.category-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background: #1890ff;
}

.category-icon {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1890ff;
  margin-right: 10px;
  opacity: 0;
  transition: all 0.3s ease;
}

.category-item.active .category-icon,
.category-item:hover .category-icon {
  opacity: 1;
}

.category-name {
  font-size: 15px;
  transition: all 0.3s ease;
}

/* 产品展示区域 */
.product-showcase {
  flex: 1;
  padding: 25px;
  min-height: 600px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}

.product-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.product-image {
  height: 220px;
  overflow: hidden;
  position: relative;
}

.product-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0) 70%, rgba(0,0,0,0.1) 100%);
  z-index: 1;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.08);
}

.product-info {
  padding: 20px;
  position: relative;
}

.product-title {
  font-size: 17px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
  transition: color 0.3s ease;
}

.product-card:hover .product-title {
  color: #1890ff;
}

.product-brief {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-action {
  display: flex;
  justify-content: flex-end;
}

.view-details {
  font-size: 14px;
  color: #1890ff;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
}

.view-details::after {
  content: '→';
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.product-card:hover .view-details::after {
  transform: translateX(3px);
}

/* 无数据提示 */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #999;
}

.no-data i {
  font-size: 48px;
  margin-bottom: 15px;
}

/* 列表动画 */
.fade-list-enter-active, .fade-list-leave-active {
  transition: all 0.5s;
}
.fade-list-enter, .fade-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* 响应式调整 */
@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .category-sidebar {
    width: 100%;
    border-radius: 12px 12px 0 0;
    padding: 15px 0;
  }
  
  .category-list {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 15px;
  }
  
  .category-item {
    padding: 8px 15px;
    margin: 5px;
    border-radius: 20px;
  }
  
  .category-item.active::before {
    display: none;
  }
  
  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
</style>